/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ENUM_APPACTIONBUTTON_OPENMODE {
  modal = 'modal',
  new_page = 'new_page',
}

export enum ENUM_DAILYBIRDSETTINGS_FONTFAMILY {
  sans = 'sans',
  serif = 'serif',
}

export enum ENUM_DAILYCHIRP_TYPE {
  bookito = 'bookito',
  dailybird = 'dailybird',
  msword = 'msword',
}

export enum ENUM_EXTERNALCONTENT_PLATFORM {
  facebook = 'facebook',
  instagram = 'instagram',
  web = 'web',
}

export enum ENUM_EXTERNALCONTENT_PUBLICATIONSTATE {
  draft = 'draft',
  published = 'published',
}

export enum ENUM_HOTEL_ACCOMODATIONTYPE {
  apartment = 'apartment',
  hotel = 'hotel',
}

export enum ENUM_HOTEL_DEALSTATUS {
  Customer = 'Customer',
  Delete = 'Delete',
  Demo = 'Demo',
  Terminated = 'Terminated',
  Test = 'Test',
}

export enum ENUM_HOTEL_PAYMENTSTATUS {
  active = 'active',
  deleted = 'deleted',
  past_due = 'past_due',
  paused = 'paused',
  trialing = 'trialing',
}

export enum ENUM_HOTEL_PMS {
  asa = 'asa',
  char = 'char',
  none = 'none',
  orderando = 'orderando',
  yanovis = 'yanovis',
}

export enum ENUM_HOTEL_POS {
  mergeport = 'mergeport',
  none = 'none',
}

export enum ENUM_PRICECLASS_FORACCOMODATIONTYPE {
  apartment = 'apartment',
  hotel = 'hotel',
}

export enum ENUM_PRODUCTTOURSTEP_PLACEMENT {
  bottom = 'bottom',
  bottom_end = 'bottom_end',
  bottom_start = 'bottom_start',
  left = 'left',
  left_end = 'left_end',
  left_start = 'left_start',
  right = 'right',
  right_end = 'right_end',
  right_start = 'right_start',
  top = 'top',
  top_end = 'top_end',
  top_start = 'top_start',
}

export enum ENUM_STAYINFORMATION_SIZE {
  big = 'big',
  default = 'default',
  small = 'small',
}

export enum ENUM_USERSPERMISSIONSUSER_DASHBOARDROLE {
  bookitoViewOnly = 'bookitoViewOnly',
  default = 'default',
}

export interface AddWidgetHostInput {
  hotelId: string;
  widgetHost: string;
}

export interface AppRatingInput {
  hotelEmployee?: string | null;
  rating?: number | null;
  hotel?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface BlogPostInput {
  hotel?: string | null;
  title?: string | null;
  content?: string | null;
  bannerImage?: string | null;
  appSortOrder?: number | null;
  website?: string | null;
  hidden?: boolean | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface DailychirpInput {
  date?: any | null;
  dailybirdData?: any | null;
  hotel?: string | null;
  type?: ENUM_DAILYCHIRP_TYPE | null;
  isFavorite?: boolean | null;
  title?: string | null;
  pdfDocuments?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface ExternalContentInput {
  title?: string | null;
  body?: string | null;
  hashtags?: string | null;
  publicationState?: ENUM_EXTERNALCONTENT_PUBLICATIONSTATE | null;
  post?: string | null;
  platform?: ENUM_EXTERNALCONTENT_PLATFORM | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface ExternalPostInput {
  hotel?: string | null;
  externalContent?: (string | null)[] | null;
  bannerImg?: string | null;
  bannerImgUrl?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface GenerateAuthTokenInput {
  existingAuthToken?: string | null;
  validUntil?: string | null;
}

export interface HotelInput {
  name: string;
  owner?: string | null;
  employees?: (string | null)[] | null;
  welcomeMessage?: string | null;
  logo?: string | null;
  code?: string | null;
  stayInformations?: (string | null)[] | null;
  stayInformationBannerImage?: string | null;
  surroundingsBannerImage?: string | null;
  surroundingInformationCategories?: (string | null)[] | null;
  blogPosts?: (string | null)[] | null;
  homeScreenBanner?: string | null;
  locationLat?: number | null;
  locationLon?: number | null;
  guests?: (string | null)[] | null;
  tvAppConfigurations?: (string | null)[] | null;
  tvAppConfiguration?: (string | null)[] | null;
  subdomain?: string | null;
  theme?: string | null;
  pricingPlan?: string | null;
  roomNumberCheckIn?: boolean | null;
  chatUserId?: string | null;
  chatAuthToken?: string | null;
  orderandoCustomercode?: string | null;
  virtualProfiles?: (string | null)[] | null;
  cloneOf?: string | null;
  roomServiceCancellation?: boolean | null;
  receptionOpenFrom?: any | null;
  receptionOpenTo?: any | null;
  showLocationQrScannerInOrderFlow?: boolean | null;
  paymentValidUntil?: any | null;
  isOnTrialPlan?: boolean | null;
  accomodationType?: ENUM_HOTEL_ACCOMODATIONTYPE | null;
  paddleSubscriptionId?: string | null;
  paymentStatus?: ENUM_HOTEL_PAYMENTSTATUS | null;
  paymentUpdateUrl?: string | null;
  paymentCancelUrl?: string | null;
  eventsModuleConfiguration?: any | null;
  reguestApiBaseUrl?: string | null;
  isExperimentalSocialMediaToolActive?: boolean | null;
  knownWidgetHosts?: any | null;
  enabledIncomingNotificationChannels?: any | null;
  enabledOutgoingNotificationChannels?: any | null;
  customOrderModuleImage?: string | null;
  availableLanguages?: any | null;
  chatEnabled?: boolean | null;
  stayInformationExternalBannerImage?: string | null;
  surroundingsExternalBannerImage?: string | null;
  homeExternalBannerImage?: string | null;
  externalOrderSystemUrl?: string | null;
  appActionButtons?: (string | null)[] | null;
  isBookitoActive?: boolean | null;
  bookitoSettings?: string | null;
  isDailybirdActive?: boolean | null;
  dailybirdSettings?: string | null;
  tvLanguages?: any | null;
  websiteUrl?: string | null;
  genericAutoMessages?: (string | null)[] | null;
  enableCustomOrderandoActionCards?: boolean | null;
  peerTvHotelId?: string | null;
  getavoCode?: string | null;
  pms?: ENUM_HOTEL_PMS | null;
  isCarlitoFoodAndBeverageModuleActive?: boolean | null;
  isCarlitoShopModuleActive?: boolean | null;
  pmsConfiguration?: any | null;
  doorControlSystemConfiguration?: any | null;
  dealStatus?: ENUM_HOTEL_DEALSTATUS | null;
  hubspotMatchingCode?: string | null;
  spaSystemConfiguration?: any | null;
  pos?: ENUM_HOTEL_POS | null;
  posConfiguration?: any | null;
  solarMonitoringConfiguration?: any | null;
  evSystemConfiguration?: any | null;
  isCarlitoEvChargingModuleActive?: boolean | null;
  isBookitoOnlyMode?: boolean | null;
  chatlynConfiguration?: any | null;
  isChatToEmailEnabled?: boolean | null;
  voucherAppCode?: string | null;
  reguestConfiguration?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface InputID {
  id: string;
}

export interface LoginByCodeInput {
  hotelCode: string;
  guestDepartureTimestamp?: string | null;
}

export interface StayInformationInput {
  bannerImage?: string | null;
  title?: string | null;
  hotel?: string | null;
  content?: string | null;
  appSortOrder?: number | null;
  tvAppSortOrder?: number | null;
  hidden?: boolean | null;
  size?: ENUM_STAYINFORMATION_SIZE | null;
  externalBannerImage?: string | null;
  parentStayInfo?: string | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface SurroundingInformationCategoryInput {
  title?: string | null;
  surroundingInformations?: (string | null)[] | null;
  hotel?: string | null;
  appSortOrder?: number | null;
  tvAppSortOrder?: number | null;
  hidden?: boolean | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface SurroundingInformationInput {
  title?: string | null;
  phoneNr?: string | null;
  website?: string | null;
  properties?: (string | null)[] | null;
  category?: string | null;
  bannerImage?: string | null;
  locationLat?: number | null;
  locationLon?: number | null;
  locationName?: string | null;
  appSortOrder?: number | null;
  shortDescription?: string | null;
  bodyText?: string | null;
  hidden?: boolean | null;
  externalBannerImage?: string | null;
  fusionarId?: string | null;
  openingTimes?: any | null;
  email?: string | null;
  disabledSynchronisationFields?: any | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface SurroundingInformationPropertyInput {
  text?: string | null;
  badgeColor?: string | null;
  surroundingInformation?: string | null;
  appSortOrder?: number | null;
  icon?: string | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface TvAppConfigurationInput {
  surroundingInformationCategories?: (string | null)[] | null;
  stayInformations?: (string | null)[] | null;
  name?: string | null;
  order?: any | null;
  hotel?: (string | null)[] | null;
  hotels?: (string | null)[] | null;
  slug?: string | null;
  screens?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface UpdatePlanInput {
  newPlanId: string;
}

export interface UsersPermissionsLoginInput {
  identifier: string;
  password: string;
  provider?: string | null;
}

export interface UsersPermissionsRegisterInput {
  username: string;
  email: string;
  password: string;
  receiveMarketingMessages?: boolean | null;
  phoneNr?: string | null;
}

export interface VirtualHotelUserInput {
  fullName?: string | null;
  profilePicture?: string | null;
  hotel?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface createDailychirpInput {
  data?: DailychirpInput | null;
}

export interface createExternalContentInput {
  data?: ExternalContentInput | null;
}

export interface createExternalPostInput {
  data?: ExternalPostInput | null;
}

export interface createHotelInput {
  data?: HotelInput | null;
}

export interface createStayInformationInput {
  data?: StayInformationInput | null;
}

export interface createTvAppConfigurationInput {
  data?: TvAppConfigurationInput | null;
}

export interface deleteVirtualHotelUserInput {
  where?: InputID | null;
}

export interface editBlogPostInput {
  hotel?: string | null;
  title?: string | null;
  content?: string | null;
  bannerImage?: string | null;
  appSortOrder?: number | null;
  website?: string | null;
  hidden?: boolean | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editDailychirpInput {
  date?: any | null;
  dailybirdData?: any | null;
  hotel?: string | null;
  type?: ENUM_DAILYCHIRP_TYPE | null;
  isFavorite?: boolean | null;
  title?: string | null;
  pdfDocuments?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editExternalContentInput {
  title?: string | null;
  body?: string | null;
  hashtags?: string | null;
  publicationState?: ENUM_EXTERNALCONTENT_PUBLICATIONSTATE | null;
  post?: string | null;
  platform?: ENUM_EXTERNALCONTENT_PLATFORM | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editExternalPostInput {
  hotel?: string | null;
  externalContent?: (string | null)[] | null;
  bannerImg?: string | null;
  bannerImgUrl?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editHotelInput {
  name?: string | null;
  owner?: string | null;
  employees?: (string | null)[] | null;
  welcomeMessage?: string | null;
  logo?: string | null;
  code?: string | null;
  stayInformations?: (string | null)[] | null;
  stayInformationBannerImage?: string | null;
  surroundingsBannerImage?: string | null;
  surroundingInformationCategories?: (string | null)[] | null;
  blogPosts?: (string | null)[] | null;
  homeScreenBanner?: string | null;
  locationLat?: number | null;
  locationLon?: number | null;
  guests?: (string | null)[] | null;
  tvAppConfigurations?: (string | null)[] | null;
  tvAppConfiguration?: (string | null)[] | null;
  subdomain?: string | null;
  theme?: string | null;
  pricingPlan?: string | null;
  roomNumberCheckIn?: boolean | null;
  chatUserId?: string | null;
  chatAuthToken?: string | null;
  orderandoCustomercode?: string | null;
  virtualProfiles?: (string | null)[] | null;
  cloneOf?: string | null;
  roomServiceCancellation?: boolean | null;
  receptionOpenFrom?: any | null;
  receptionOpenTo?: any | null;
  showLocationQrScannerInOrderFlow?: boolean | null;
  paymentValidUntil?: any | null;
  isOnTrialPlan?: boolean | null;
  accomodationType?: ENUM_HOTEL_ACCOMODATIONTYPE | null;
  paddleSubscriptionId?: string | null;
  paymentStatus?: ENUM_HOTEL_PAYMENTSTATUS | null;
  paymentUpdateUrl?: string | null;
  paymentCancelUrl?: string | null;
  eventsModuleConfiguration?: any | null;
  reguestApiBaseUrl?: string | null;
  isExperimentalSocialMediaToolActive?: boolean | null;
  knownWidgetHosts?: any | null;
  enabledIncomingNotificationChannels?: any | null;
  enabledOutgoingNotificationChannels?: any | null;
  customOrderModuleImage?: string | null;
  availableLanguages?: any | null;
  chatEnabled?: boolean | null;
  stayInformationExternalBannerImage?: string | null;
  surroundingsExternalBannerImage?: string | null;
  homeExternalBannerImage?: string | null;
  externalOrderSystemUrl?: string | null;
  appActionButtons?: (string | null)[] | null;
  isBookitoActive?: boolean | null;
  bookitoSettings?: string | null;
  isDailybirdActive?: boolean | null;
  dailybirdSettings?: string | null;
  tvLanguages?: any | null;
  websiteUrl?: string | null;
  genericAutoMessages?: (string | null)[] | null;
  enableCustomOrderandoActionCards?: boolean | null;
  peerTvHotelId?: string | null;
  getavoCode?: string | null;
  pms?: ENUM_HOTEL_PMS | null;
  isCarlitoFoodAndBeverageModuleActive?: boolean | null;
  isCarlitoShopModuleActive?: boolean | null;
  pmsConfiguration?: any | null;
  doorControlSystemConfiguration?: any | null;
  dealStatus?: ENUM_HOTEL_DEALSTATUS | null;
  hubspotMatchingCode?: string | null;
  spaSystemConfiguration?: any | null;
  pos?: ENUM_HOTEL_POS | null;
  posConfiguration?: any | null;
  solarMonitoringConfiguration?: any | null;
  evSystemConfiguration?: any | null;
  isCarlitoEvChargingModuleActive?: boolean | null;
  isBookitoOnlyMode?: boolean | null;
  chatlynConfiguration?: any | null;
  isChatToEmailEnabled?: boolean | null;
  voucherAppCode?: string | null;
  reguestConfiguration?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editStayInformationInput {
  bannerImage?: string | null;
  title?: string | null;
  hotel?: string | null;
  content?: string | null;
  appSortOrder?: number | null;
  tvAppSortOrder?: number | null;
  hidden?: boolean | null;
  size?: ENUM_STAYINFORMATION_SIZE | null;
  externalBannerImage?: string | null;
  parentStayInfo?: string | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editSurroundingInformationCategoryInput {
  title?: string | null;
  surroundingInformations?: (string | null)[] | null;
  hotel?: string | null;
  appSortOrder?: number | null;
  tvAppSortOrder?: number | null;
  hidden?: boolean | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editSurroundingInformationInput {
  title?: string | null;
  phoneNr?: string | null;
  website?: string | null;
  properties?: (string | null)[] | null;
  category?: string | null;
  bannerImage?: string | null;
  locationLat?: number | null;
  locationLon?: number | null;
  locationName?: string | null;
  appSortOrder?: number | null;
  shortDescription?: string | null;
  bodyText?: string | null;
  hidden?: boolean | null;
  externalBannerImage?: string | null;
  fusionarId?: string | null;
  openingTimes?: any | null;
  email?: string | null;
  disabledSynchronisationFields?: any | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editSurroundingInformationPropertyInput {
  text?: string | null;
  badgeColor?: string | null;
  surroundingInformation?: string | null;
  appSortOrder?: number | null;
  icon?: string | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editThemeInput {
  primary?: string | null;
  secondary?: string | null;
  tertiary?: string | null;
  success?: string | null;
  warning?: string | null;
  danger?: string | null;
  dark?: string | null;
  medium?: string | null;
  light?: string | null;
  hotel?: string | null;
  actionPrimary?: string | null;
  actionSecondary?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editTvAppConfigurationInput {
  surroundingInformationCategories?: (string | null)[] | null;
  stayInformations?: (string | null)[] | null;
  name?: string | null;
  order?: any | null;
  hotel?: (string | null)[] | null;
  hotels?: (string | null)[] | null;
  slug?: string | null;
  screens?: any | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editUserInput {
  username?: string | null;
  email?: string | null;
  provider?: string | null;
  password?: string | null;
  resetPasswordToken?: string | null;
  confirmationToken?: string | null;
  confirmed?: boolean | null;
  blocked?: boolean | null;
  role?: string | null;
  phoneNr?: string | null;
  receiveMarketingMessages?: boolean | null;
  profilePicture?: string | null;
  ownerOf?: string | null;
  employeeOf?: string | null;
  guestOf?: string | null;
  roomNr?: string | null;
  dashboardRole?: ENUM_USERSPERMISSIONSUSER_DASHBOARDROLE | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editVirtualHotelUserInput {
  fullName?: string | null;
  profilePicture?: string | null;
  hotel?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface editWelcomeMessageInput {
  title?: string | null;
  subtitle?: string | null;
  bodyText?: string | null;
  hotel?: string | null;
  bannerImage?: string | null;
  externalBannerImage?: string | null;
  localizations?: (string | null)[] | null;
  locale?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface updateBlogPostInput {
  where?: InputID | null;
  data?: editBlogPostInput | null;
}

export interface updateDailychirpInput {
  where?: InputID | null;
  data?: editDailychirpInput | null;
}

export interface updateExternalContentInput {
  where?: InputID | null;
  data?: editExternalContentInput | null;
}

export interface updateExternalPostInput {
  where?: InputID | null;
  data?: editExternalPostInput | null;
}

export interface updateHotelInput {
  where?: InputID | null;
  data?: editHotelInput | null;
}

export interface updateStayInformationInput {
  where?: InputID | null;
  data?: editStayInformationInput | null;
}

export interface updateSurroundingInformationCategoryInput {
  where?: InputID | null;
  data?: editSurroundingInformationCategoryInput | null;
}

export interface updateSurroundingInformationInput {
  where?: InputID | null;
  data?: editSurroundingInformationInput | null;
}

export interface updateSurroundingInformationPropertyInput {
  where?: InputID | null;
  data?: editSurroundingInformationPropertyInput | null;
}

export interface updateThemeInput {
  where?: InputID | null;
  data?: editThemeInput | null;
}

export interface updateTvAppConfigurationInput {
  where?: InputID | null;
  data?: editTvAppConfigurationInput | null;
}

export interface updateUserInput {
  where?: InputID | null;
  data?: editUserInput | null;
}

export interface updateVirtualHotelUserInput {
  where?: InputID | null;
  data?: editVirtualHotelUserInput | null;
}

export interface updateWelcomeMessageInput {
  where?: InputID | null;
  data?: editWelcomeMessageInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
